import { render, staticRenderFns } from "./FormCliente.vue?vue&type=template&id=89d4550e&scoped=true"
import script from "./FormCliente.vue?vue&type=script&lang=js"
export * from "./FormCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d4550e",
  null
  
)

export default component.exports